<template>
    <div class="default-layout" id="top">
        <default-header></default-header>
        <cookie-consent></cookie-consent>
        <router-view></router-view>
        <default-footer></default-footer>
    </div>
</template>

<script>
    import DefaultHeader from "../../DefaultHeader/DefaultHeader";
    import DefaultFooter from "../../DefaultFooter/DefaultFooter";
    import CookieConsent from "@/components/CookieConsent/CookieConsent.vue";
    import VueScrollTo from 'vue-scrollto';
    export default {
        name: "DefaultLayout",
        components: {DefaultFooter, DefaultHeader, CookieConsent},
        watch: {
            $route() {
                VueScrollTo.scrollTo('#top')
            }
        }
    }
</script>
